// extracted by mini-css-extract-plugin
module.exports = {"Blob-info":"Blob_Blob-info__9SAM4","Blob-works":"Blob_Blob-works__23Kju"};